import React from 'react';
import { Loader2 } from 'lucide-react';
import { usePortalWalkthrough } from './PortalWalkthroughContext';

export default function TourLoadingOverlay() {
  const {
    isActive,
    isPageReady,
    isPendingCompletion,
    currentSectionId,
    completedIds,
    pendingAutoStartPath
  } = usePortalWalkthrough() || {};

  if (isPendingCompletion) {
    // Saving section progress after first-time reload — show overlay until confirmed.
  } else if (pendingAutoStartPath) {
    // First-time auto-start: waiting for page data before the tour begins.
  } else if (!isActive || isPageReady) {
    return null;
  }

  const isInitialSetup =
    currentSectionId === 'checklist' ||
    (completedIds?.length === 0 &&
      (currentSectionId === 'home' || !currentSectionId));

  const message = isPendingCompletion
    ? 'Saving your progress…'
    : pendingAutoStartPath
    ? 'Loading page…'
    : isInitialSetup
    ? 'Setting up tour…'
    : 'Preparing next section…';

  return (
    <div
      className='fixed inset-0 z-10000 flex items-center justify-center bg-black/50'
      role='status'
      aria-live='polite'
      aria-busy='true'
    >
      <div className='flex flex-col items-center gap-3 rounded-xl bg-white px-8 py-6 shadow-[0_8px_32px_rgba(0,0,0,0.2)]'>
        <Loader2
          size={32}
          className='animate-spin text-primary'
          aria-hidden='true'
        />
        <p className='m-0 text-base font-medium text-gray-800'>{message}</p>
      </div>
    </div>
  );
}
